// authTimer.js
import { logout } from '../slices/authSlice';

let timerId = null;

// FIX: comment said "5 minutes" but value was 2 minutes — aligned both to 8 hours
// to match the new JWT expiry in generateToken.js.  The inactivity window is
// deliberately generous (8h = a full shift); the JWT on the server enforces the
// hard limit regardless of what the client does.
const INACTIVITY_MS = 8 * 60 * 60 * 1000; // 8 hours

export const resetTimer = () => {
  const expirationTime = new Date().getTime() + INACTIVITY_MS;
  localStorage.setItem('expirationTime', expirationTime);
};

export const startAuthTimer = (dispatch, navigate) => {
  clearAuthTimer();

  timerId = setInterval(() => {
    const expirationTime = localStorage.getItem('expirationTime');

    if (!expirationTime) return;

    const currentTime = new Date().getTime();

    if (currentTime > Number(expirationTime)) {
      dispatch(logout());
      clearAuthTimer();
      navigate('/login');
    }
  }, 60000); // check every minute
};

export const clearAuthTimer = () => {
  if (timerId) {
    clearInterval(timerId);
    timerId = null;   // FIX: null out after clearing to prevent stale ID bugs
  }
};
